export default "__VITE_ASSET__a7b306cf__"